import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Get from localStorage at load
const userFromStorage = localStorage.getItem('user');
const tokenFromStorage = localStorage.getItem('token');

// Async thunk for login
export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async (loginData, thunkAPI) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL ?? "https://backend.carbez.com"}/api/auth/login-employee`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(loginData),
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        return thunkAPI.rejectWithValue(errorData.message || 'Login failed');
      }

      const data = await response.json();
      return data; // Should include { token, user }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || 'Login failed');
    }
  }
);



// Async thunk for token validation
export const validateToken = createAsyncThunk(
    'auth/validateToken',
    async (token, thunkAPI) => {
        try {
            const response = await fetch( `${process.env.REACT_APP_BASE_URL ?? "https://backend.carbez.com"}/api/auth/validate-token`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                      },
                }
            );

            if (!response.ok) {
                const errorData = await response.json();
                return thunkAPI.rejectWithValue(errorData.message || 'Token validation failed');
            }

            const data = await response.json();
            return data; // Should include { user }
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message || 'Token validation failed');
        }
    }
);

// Async thunk for logout
export const logoutUser = createAsyncThunk(
    'auth/logoutUser',
    async (_, thunkAPI) => {
        try {
            // Remove token and user from localStorage
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            window.location.href = '/signin'
            return true; // Indicate successful logout
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message || 'Logout failed');
        }
    }
);

const initialState = {
    user: userFromStorage ? JSON.parse(userFromStorage) : null,
    token: tokenFromStorage || null,
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
    valid: true,
};

const loginSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout(state) {
            state.user = null;
            state.token = null;
            state.status = 'idle';
            state.error = null;
            state.valid = false;
            localStorage.removeItem('user');
            localStorage.removeItem('token');
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.user = action.payload.user;
                state.token = action.payload.token;

                // Store in localStorage
                localStorage.setItem('user', JSON.stringify(action.payload.user));
                localStorage.setItem('token', action.payload.token);
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'Login failed';
            })
            .addCase(validateToken.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(validateToken.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.valid = action.payload.valid;
                if (action.payload.user) {
                    state.user = action.payload.user;
                }
            })
            .addCase(validateToken.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'Token validation failed';
                state.valid = false;
            });
    },
});


export const { logout } = loginSlice.actions;
export default loginSlice.reducer;
